import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgArrowLeftDoubleIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.6 16.59 14.02 12l4.58-4.59L17.19 6l-6 6 6 6z" />
    <path d="m12.731 16.85-4.58-4.59 4.58-4.59-1.41-1.41-6 6 6 6z" />
    <path fill="none" d="M0 0h24v24H0Z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgArrowLeftDoubleStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgArrowLeftDoubleIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ArrowLeftDoubleIcon: any = SvgArrowLeftDoubleStyle;
export default ArrowLeftDoubleIcon;
